/** Remaining balances are whole credits. Millicredits stay in the ledger. */

export function wholeCredits(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.round(n));
}

export function formatCreditBalance(value) {
  return wholeCredits(value).toLocaleString();
}

/**
 * Composer chip shows the context-aware estimate. The long-reply reserve is
 * only used to gate sending and to explain the tap-through breakdown.
 */
export function resolveComposerCreditQuote(estimate, hold) {
  const estimated = Number.isFinite(Number(estimate)) ? Math.max(0, Number(estimate)) : 0;
  const reserved = Math.max(
    estimated,
    Number.isFinite(Number(hold)) ? Math.max(0, Number(hold)) : 0,
  );
  return {
    estimated,
    reserved,
    hasLongReplyReserve: reserved > estimated,
  };
}

/**
 * Rewrite millicredit / float-error amounts in user-facing copy so a stored
 * ask_user card never shows 43653.797770700001.
 */
export function formatCreditsInText(text) {
  return String(text ?? '').replace(
    /\d+\.\d+(?=\s*credits\b)|\d+\.\d{3,}/gi,
    (raw) => formatCreditBalance(raw),
  );
}
